import { isRenamingColumnsEnabled } from '@thoughtspot/session-service';
import { getAggregationTypeLabelsMap as aggregationTypeLabelsMap, getName as getColumnName, } from '@thoughtspot/visualization-column-util';
import { getTranslatedTextCallback } from '../env';
export const getName = (col, skipPrefix = false) => {
    return isRenamingColumnsEnabled() && col.isUserDefinedTitle
        ? col.name
        : getColumnName(col, getTranslatedTextCallback(), skipPrefix);
};
export const getOriginalColumnName = (col) => {
    return getColumnName(col, getTranslatedTextCallback());
};
export const getAggregationTypeLabelsMap = (column) => {
    return aggregationTypeLabelsMap(getTranslatedTextCallback(), column);
};
//# sourceMappingURL=column-name-util.js.map